module.exports = __webpack_public_path__ + "img/price-drop.ca55dcd5.svg";